import React from 'react';

interface History {
  handleCancel: () => void;
}
/**
 * rilo
 * @param properties
 * @returns
 */
function WithdrawalHistory(properties: History) {
  const { handleCancel } = properties;
  console.log(handleCancel);
  const transactions = [
    { sno: '01', date: '17-09-2024', amount: '12000/-', account: 'SBI09876098xxxx' },
    { sno: '02', date: '18-09-2024', amount: '12000/-', account: 'SBI09876098xxxx' },
    { sno: '03', date: '19-09-2024', amount: '12000/-', account: 'SBI09876098xxxx' },
    { sno: '04', date: '20-09-2024', amount: '12000/-', account: 'SBI09876098xxxx' },
    { sno: '05', date: '25-09-2024', amount: '12000/-', account: 'SBI09876098xxxx' },
  ];
  return (
    <div className="history-container">
      <div className="withdrawal-header">
        <p>S.No</p>
        <p>Date</p>
        <p>Withdraw Amount</p>
        <p>Recipient Account</p>
      </div>
      <div className="transaction-list">
        {transactions.map((transaction) => (
          <div className="transaction-card" key={transaction.sno}>
            <div className="transaction-detail">{transaction.sno}</div>
            <div className="transaction-detail">{transaction.date}</div>
            <div className="transaction-detail">{transaction.amount}</div>
            <div className="transaction-detail">{transaction.account}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WithdrawalHistory;
